import { useQuery } from "@tanstack/react-query";
import { getTaskCommentsQueryKey } from "./queryKeyHelper";
import { getTaskComments } from "./tasks.service";
import { createPreviousOnNullPlaceholderDataFn } from "@coworker/apprestructured/src/task-management/services/queryHelper";
import { Comment } from "@coworker/apprestructured/src/task-management/types/Comment";

export const useTaskComments = (id: string | null) => {
  return useQuery({
    queryKey: getTaskCommentsQueryKey(id),
    queryFn: () => getTaskComments(id!),
    enabled: id !== null,
    placeholderData: createPreviousOnNullPlaceholderDataFn<Comment[]>(id),
  });
};
